import * as t from "io-ts"
import { UUID } from "io-ts-types/lib/UUID"
import { cast, maybe } from "@flockcover/flock-svc-core-types"

const StatusType = t.keyof({
  Cancelled: null,
  Lapsed: null,
  Active: null,
  Void: null,
  Inactive: null,
})

const Deposit = t.type({
  rate: t.number,
  premium: t.type({
    net: t.number,
    brokerage: t.number,
    tax: t.number,
    fee: t.number,
    grossDiscount: t.number,
    taxDiscount: t.number,
  }),
})

const PolicyType = t.intersection([
  t.type({
    id: UUID,
    number: t.string,
    insuredName: t.string,
    issueDate: t.string,
    product: t.string,
    premium: t.string,
    status: StatusType,
    insuredId: UUID,
    nonQuoted: t.boolean,
    connectivityRate: maybe(t.number),
  }),
  t.partial({
    meta: t.partial({
      vertical: t.literal(`motor`),
      productType: t.union([t.literal(`flat_fee`), t.literal(`usage_based`), t.literal(`rebates`)]),
      billingProcess: t.union([
        t.type({
          type: t.literal(`distributed`),
          deposit: Deposit,
        }),
        t.type({
          type: t.literal(`deposit_only`),
          deposit: Deposit,
        }),
        t.type({
          type: t.literal(`premium_finance`),
          deposit: Deposit,
          provider: t.string,
        }),
        t.type({
          type: t.literal(`bundled`),
        }),
      ]),
      nonQuoted: t.union([t.boolean, t.undefined]),
      modern: t.union([t.boolean, t.undefined]),
      fleetId: t.union([t.string, t.undefined]),
      inceptingVehicleSetId: t.union([t.string, t.undefined]),
    }),
  }),
])

export type Status = t.TypeOf<typeof StatusType>
export type Policy = t.TypeOf<typeof PolicyType>

export const makePolicy = cast(PolicyType)
